export default __webpack_public_path__ + "static/about-decor-3-f54ac33441c82f0deb673d08087d68a1.png";